<template>
	<div class="mainWrapper po">
		<h1>Product Transfer Detail</h1>
		<div class="po-details" v-if="transfer">
			<div class="first-row">
				<div class="details">
					<span>TRANSFER CODE</span> <br />
					{{ transfer.code }}
				</div>
				<div class="details">
					<span>TRANSFER DATE</span> <br />
					{{ convertTime(transfer.transfer_date) }}
				</div>
				<div class="details">
					<span>CREATED</span> <br />
					{{ convertTime(transfer.createdAt) }}
				</div>
			</div>

			<div class="list">
				<div class="poItemList header">
					<div>BD CODE</div>
					<div>BARCODE</div>
					<div>PRODUCT NAME</div>
					<div>FROM</div>
					<div>TO</div>
					<div>REQUESTED QUANTITY</div>
					<div>REMARK</div>
				</div>

				<div v-for="(item, index) of transfer.product" v-bind:key="index" class="poItemList">
					<div>{{ item.product.bd_code }}</div>
					<div>{{ item.product.barcode }}</div>
					<div>{{ item.product.name }}</div>
					<div>{{ item.from }}</div>
					<div>{{ item.to }}</div>
					<div>{{ item.stock }}</div>
					<div>{{ item.description }}</div>
				</div>
			</div>

			<div class="po-detail-buttons-wrapper">
				<div class="align-left">
					<b-button type="is-dark" icon-left="arrow-left" @click="back()">BACK</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WarehouseTransferDetail',
	data: function() {
		return {
			transferID: this.$route.params.id, //id from get url
			transfer: null // PO details
		}
	},
	mounted: async function() {
		var data = {
			id: this.transferID,
			populate: ['author', 'shop', 'brand', 'product.product']
		}

		const apiGetTransfer = await this.$api.getStockTransfer({ data })

		this.transfer = apiGetTransfer.data.list[0]

		console.log(apiGetTransfer)
	},
	methods: {
		createPI: function() {
			// this.$router.push("/pi/view/" + this.poId);
			const id = this.poId
			this.$router.push({ name: 'createPi', params: { id } })
		},
		back: function() {
			this.$router.go(-1)
		},
		// Convert time
		convertTime: function(time) {
			if (time) {
				return this.$moment(time).format('DD/MM/YY')
			} else {
				return ''
			}
		}
	}
}
</script>

<style scoped>
.poList {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 50px;
	grid-gap: 10px;
	padding: 16px 5px 5px;
	font-weight: bold;
	font-size: 14px;
	color: #000;
	border-bottom: 1px solid #eee;
}

.first-row {
	margin: 30px auto;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 10px;
	text-align: left;
	font-weight: 600;
	font-size: 14px;
}

.second-row {
	margin: auto;
	text-align: left;
	font-weight: bold;
}

.poItemList {
	margin: auto;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
	grid-gap: 10px;
	padding: 20px 5px;
	font-weight: bold;
	font-size: 14px;
	color: #000;
	border-bottom: 1px solid #eee;
}

.remark {
	width: 100%;
	height: 50px;
	border-radius: 4px;
	border: 1px solid #ccc;
	background-color: #fff;
	padding: 5px;
	color: #000;
	font-size: 14px;
	overflow-wrap: break-word;
}

.header {
	color: #aaa;
	font-weight: bold;
	font-size: 14px;
	margin-bottom: 10px;
}

.firstRow .details {
	margin: 10px;
	color: #777;
}

.details span {
	font-size: 12px;
	color: #999;
	font-weight: bold;
}

.po-detail-buttons-wrapper {
	display: grid;
	grid-template-columns: 1fr 1fr;
	margin: auto;
}

.align-left {
	text-align: left;
}

.align-right {
	text-align: right;
}

.qtyInput {
	width: 90px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
	/* background: #70a15a; */
}

.priceInput {
	width: 150px;
	height: 30px;
	border: 0;
	text-align: center;
	border-radius: 5px;
	padding-left: 10px;
	font-size: 14px;
	font-weight: bold;
	color: #000;
	background-color: #f5f5f5;
}

.calenderInput {
	width: 150px;
	text-align: center;
	margin: auto;
}

.po .closed {
	height: 40px;
	width: 100px;
	border-radius: 5px;
	padding-top: 10px;
	background: #e25b5b;
	margin: auto;
	color: #fff;
}

.po .opened {
	height: 40px;
	width: 100px;
	border-radius: 5px;
	padding-top: 10px;
	background: #129d7b;
	margin: auto;
	color: #fff;
}
</style>
